/*  ========================================================================
    # Scripts - Contact Dialog
    ========================================================================  */

import { animate } from 'motion';

/**
 * Script that handles the contact dialog.
 */
const ContactDialog = {
  cfg: {
    contactButtons: document.querySelectorAll('.c-contact-button'),
    contactDialog: document.querySelector('.c-contact-dialog')
  },

  /**
   * Handle accordion triggers.
   */
  handleContactDialog() {
    const dialog = this.cfg.contactDialog;
    const dialogClose = dialog.querySelector('.c-contact-dialog__close');
    const dialogWrapper = dialog.querySelector('.c-contact-dialog__wrapper');
    animate(dialog, { opacity: 0 });
    animate(dialogWrapper, { opacity: 0, y: 20 });

    this.cfg.contactButtons.forEach(item => {
      item.addEventListener('click', () => {
        dialog.showModal();
        animate(dialog, { opacity: 1 });
        animate(dialogWrapper, { opacity: 1, y: 0 }, { delay: 0.2 });
        document.body.style.overflowY = 'hidden';
      });

      dialogClose.addEventListener('click', async () => {
        animate(dialog, { opacity: 0 });
        const wrapperAnimation = animate(dialogWrapper, { opacity: 0, y: 20 });

        // Wait for the animation to finish before closing the dialog.
        wrapperAnimation.then(() => {
          dialog.close();
        });
      });

      dialog.addEventListener('close', () => {
        document.body.style.overflowY = 'unset';
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.contactButtons.length > 0) {
      this.handleContactDialog();
    }
  }
};

export default ContactDialog;
